module.exports = __webpack_public_path__ + "static/img/CBZ.7bb159a3.png";